import { useProfileMergeStore } from "@/stores/profile-merge-store";

/** Active-step wiring for one merge card of the guided review (see
 *  ProfileMergeGuide): capture handlers that pull the guide to the card on any
 *  interaction inside it. The guide scrolls to the card's DECISION CONTROLS
 *  (MergeGuideControls owns that ref), not to the card box, so no card ref is
 *  needed here. */
export function useGuideCard(stepKey: string): {
  activationProps: { onClickCapture: () => void; onFocusCapture: () => void };
} {
  const activateStep = useProfileMergeStore((s) => s.activateStep);
  const activate = () => activateStep(stepKey);
  return { activationProps: { onClickCapture: activate, onFocusCapture: activate } };
}
